import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { RepayMethodPage } from './repay-method.page';
import { RepayMethodPageRoutingModule } from './repay-method-routing.module';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    RepayMethodPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [RepayMethodPage],
  exports: [RepayMethodPage]
})
export class RepayMethodPageModule {}
